import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let _root = this;

export default class Parallax {
    constructor() {
        _root = this;
        this.refresh();
    }

    refresh() {
        this.setSize();
    }

    setSize() {

        this.startMoveElements();
        this.startMoveBgParallax();

        // if (window.innerWidth >= 992) {
        //     this.startMoveElements();
        //     this.startMoveBgParallax();
            
        // }
        this.startCircularProgress();
    }

    startMoveElements() {


        gsap.utils.toArray(".parallax-image-scale").forEach(item => {

            gsap.set( item, { scale: 1.2 } );

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    scrub: true
                }
            });

            tl.to(
                item, {
                    scale: 1,
                    transformOrigin: "center center",
                    ease: "none"
                }, 0);


        });


    let element = document.querySelectorAll('.parallax-item');

    if ('undefined' != typeof element && null != element) {

        gsap.utils.toArray(".parallax-item").forEach(layer => {

            if (layer.dataset.scroll != null) {

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: layer.parentElement,
                        scrub: true
                    }
                });

                let speed = 1;
                let direction = 'vertical';
                let movement = -(layer.offsetHeight * speed);

                if (layer.dataset.speed) {
                    speed = layer.dataset.speed;
                }

                if (layer.dataset.direction) {
                    direction = layer.dataset.direction;
                }

                if (direction == "vertical") {
                    movement = -(layer.offsetHeight * speed);
                    tl.to( layer, { y: movement, ease: "none" }, 0 );
                }

                if (direction == "horizontal") {
                    movement = -(layer.offsetWidth * speed);
                    tl.to( layer, { x: movement, ease: "none" }, 0 );
                }

                if (direction == "rotate") {
                    tl.to(
                        layer, {
                            rotation: speed,
                            transformOrigin: "center center",
                            ease: "none"
                        }, 0);

                }

                if (direction == "scale") {
                    tl.to(
                        layer, {
                            scale: speed,
                            transformOrigin: "center center",
                            ease: "none"
                        }, 0);

                }

            }

        });

    }

}

    startMoveBgParallax() {

        let element = document.querySelectorAll('.parallax--container');

        if ('undefined' != typeof element && null != element) {
    
            gsap.utils.toArray(".parallax--container--img").forEach(section => {
                const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;
    
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section.parentElement,
                        scrub: true
                    }
                });
    
                tl.to(
                    section, {
                        y: -heightDiff,
                        ease: "none"
                    }, 0);
            });
        }

    }

    startCircularProgress() {

        const circles = document.querySelectorAll('.circular-pbar');
    
        circles.forEach((element) => {
    
            const counter = element.querySelector(".circular-pbar-counter");
            const target = counter.textContent.replaceAll(/\s/g, '')+"%";
    
            const tm = gsap.timeline({
                defaults: {
                    duration: 4,
                    ease: 'expo.out'
                },
                scrollTrigger: {
                    trigger: element,
                    toggleActions: "play pause resume reset"
                }
            });
    
            tm.from(counter, {
                textContent: 0,
                modifiers: {
                    textContent: textContent => target
                }
            });
    
            tm.to(element, {
                "--p": target,
            }, 0);
    
        })
        


    }

}
